export var FOLDER_REPOSITORY = 'FOLDER_REPOSITORY';